import { get as _get } from "lodash";
import api from "../../helpers/api";

import { objectToParams } from "../../helpers/utils";

export const getDataSources = () => {

  return api().get("/search/enrich_setup_fields").then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching data source details."),
      data: {}
    };
  });
}

export const initiateEnrichSearch = (variables) => {

  return api().post("/search/initiate_enrich", (variables || {})).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while initiating enrich."),
      data: {}
    };
  });
}

export const getSavedSearchRecords = (variables) => {
  const params = objectToParams(variables);

  return api().get(`/search/saved_record_count?${params}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching saved search total records."),
      data: {}
    };
  });
}
